import { render, staticRenderFns } from "./CBreadCrumb.vue?vue&type=template&id=a0c0647c&"
import script from "./CBreadCrumb.vue?vue&type=script&lang=js&"
export * from "./CBreadCrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports